import { useScopedSelector, SafeHtml } from 'ia-react-core';
import React, { FC } from 'react';
import InformativeMessageResource from './InformativeMessageResource';
import { StyledAside, InformativeMessageGlobalStyles, StyledContainer, StyledDiv, StyledSitecoreMessage } from './InformativeMessage.styles';

export interface InformativeMessageProps { }

const InformativeMessage: FC<InformativeMessageProps> = () => {
  const sitecoreInformativeMessage: string = useScopedSelector('SiteCoreInformativeMessage');
  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const divInformativeMessage: HTMLElement = document.getElementById('StyledInformativeMessageID');
    const divWidgetHeader = document.getElementsByClassName('okta-sign-in-header auth-header');
    /* istanbul ignore next */
    if (divInformativeMessage == null && divWidgetHeader.length > 0) {
      divWidgetHeader[0].setAttribute('style', 'border-bottom:0px solid #ddd !important');
    }
  }, []);
  return (
    <StyledContainer>
      <InformativeMessageResource />
      <InformativeMessageGlobalStyles />
      {sitecoreInformativeMessage != null &&
        <StyledAside id="StyledInformativeMessageID">
          <StyledDiv>
            <StyledSitecoreMessage>
              <SafeHtml
                allowedTags={['div', 'svg', 'path', 'a', 'br']}
                allowedAttr={['id', 'class', 'style', 'xmlns', 'height', 'width', 'viewBox', 'd', 'fill', 'href', 'target', 'aria-label']}
              >
                {sitecoreInformativeMessage}
              </SafeHtml>
            </StyledSitecoreMessage>
          </StyledDiv>
        </StyledAside>}
    </StyledContainer>
  );
};

export default InformativeMessage;
